const mkCol = (key, label, { headerCls = '', cellCls = '' } = {}) => ({
  key,
  label,
  type: 'component',
  sorted: false,
  fixed: false,
  headerClassName: headerCls,
  cellClassName: cellCls,
})

/**
 * Columnas del prototipo: Razón social, CUIT, Contrato, Nro. póliza y la
 * acción de ingresar (sin encabezado).
 *
 * El orden lo resuelve `ordenarCuentas`, no la tabla: la cuenta activa tiene
 * que quedar primera aunque el usuario no ordene nada, así que ninguna columna
 * se marca como `sorted`.
 */
export const cuentasSeleccionColumns = [
  mkCol('RAZON_SOCIAL', 'Razón social', {
    headerCls: 'w-[280px] min-w-[280px] max-w-[280px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[280px] min-w-[280px] max-w-[280px] shrink-0 grow-0 text-left',
  }),

  mkCol('CUIT', 'CUIT', {
    headerCls: 'w-[160px] min-w-[160px] max-w-[160px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[160px] min-w-[160px] max-w-[160px] shrink-0 grow-0 text-left',
  }),

  mkCol('CONTRATO', 'Contrato', {
    headerCls: 'w-[140px] min-w-[140px] max-w-[140px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[140px] min-w-[140px] max-w-[140px] shrink-0 grow-0 text-left',
  }),

  mkCol('POLIZA', 'Nro. póliza', {
    headerCls: 'w-[160px] min-w-[160px] max-w-[160px] shrink-0 grow-0 truncate text-left',
    cellCls: 'w-[160px] min-w-[160px] max-w-[160px] shrink-0 grow-0 text-left',
  }),

  mkCol('ACCION', '', {
    headerCls: 'w-[120px] min-w-[120px] max-w-[120px] shrink-0 grow-0 text-right',
    cellCls: 'w-[120px] min-w-[120px] max-w-[120px] shrink-0 grow-0 text-right',
  }),
]
